const CLARITY_EVENT_NAME_PATTERN = /^[a-z0-9_]{1,64}$/;

const getClarity = () => {
  if (typeof window === "undefined") {
    return null;
  }

  window.clarity = window.clarity || function clarityQueue() {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  return window.clarity;
};

export const trackClarityEvent = (eventName) => {
  if (!CLARITY_EVENT_NAME_PATTERN.test(String(eventName || ""))) {
    return false;
  }

  try {
    getClarity()?.("event", eventName);
    return true;
  } catch (error) {
    // Product analytics must never interrupt a customer action.
    return false;
  }
};

